
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Component, OnInit, EventEmitter, ElementRef, ViewEncapsulation, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { DialogPanelComponentContent } from '../../models/dialogs/DialogPanelComponentContent';
import { AppState } from '../../interfaces/app-state.interface';
import { FormsUtils } from '../../resources/forms.utils';
import { TokenChannel } from '../../enum/token-channel.enum';
import { AuthorizationResultPayload } from '../../models/authorization/authorization-result-payload.model';
import { AuthorizationResult } from '../../enum/authorization-result.enum';
import { AuthorizationScenario } from '../../enum/authorization-scenario.enum';
import { Token } from '../../models/authentication/token.model';
import { TokenType } from '../../enum/token-type.enum';
import { TokenType as TokenTypeToValidate } from './components/validate-token/validate-token.component';
import { AuthorizationAction } from '../../state-management/authorization/authorization.action';
import { StorageService } from '../../services/storage.service';
import { TokenCategory } from '../../enum/token-category.enum';
import { AuthorizationPages } from '../../enum/authotization-pages.enum';
import { TrackingActions } from '../../state-management/tracking/tracking.action';
import { UsersAction } from '../../state-management/users/users.actions';
import { AuthorizationReason } from './../../enum/authorization-reason.enum';
import { SettingsService } from '../../../shared/services/settings/settings.service';
import { ALLOW_EMAIL_COOKIE } from '../../../shared/constants/cookies';
import {ZendeskHelpButtonComponent } from "../../../shared/components/zendesk-help-button/zendesk-help-button.component";
import { CaptchaService } from '../../../shared/services/captcha/captcha.service';
declare var tokenWebApp;

const REMEMBER_TOKEN_CHECKBOX_STORAGE_KEY = 'hub$login$remember_token';
const mapScenarioToReason = {
    [AuthorizationScenario.AddBankAccount]: AuthorizationReason.AddBankAccount,
    [AuthorizationScenario.CancelPackage]: AuthorizationReason.CancelPackage,
    [AuthorizationScenario.ChangeAddress]: AuthorizationReason.ChangeAdress,
    [AuthorizationScenario.ChangeBusinessAddress]: AuthorizationReason.ChangeBusinessAddress,
    [AuthorizationScenario.ChangeBusinessIncomeDequity]: AuthorizationReason.ChangeBusinessIncomeDequity,
    [AuthorizationScenario.ChangeDataBusiness]: AuthorizationReason.ChangeDataBusiness,
    [AuthorizationScenario.ChangeEmail]: AuthorizationReason.ChangeEmail,
    [AuthorizationScenario.ChangeIncome]: AuthorizationReason.ChangeIncome,
    [AuthorizationScenario.ChangeLimitRisk]: AuthorizationReason.ChangeLimitRisk,
    [AuthorizationScenario.ChangeName]: AuthorizationReason.ChangeName,
    [AuthorizationScenario.ChangePassword]: AuthorizationReason.ChangePassword,
    [AuthorizationScenario.ChangePersonalData]: AuthorizationReason.ChangePersonalData,
    [AuthorizationScenario.ChangeSocietalStruture]: AuthorizationReason.ChangeSocietalStruture,
    [AuthorizationScenario.ChangeToZeroBrokerage]: AuthorizationReason.ChangeToZeroBrokerage,
    [AuthorizationScenario.DeleteBankAccount]: AuthorizationReason.DeleteBankAccount,
    [AuthorizationScenario.SubmitPackage]: AuthorizationReason.SubmitPackage,
    [AuthorizationScenario.UnlockAccount]: AuthorizationReason.UnlockAccount,
    _default: AuthorizationReason.Login,
};

const CAN_REMEMBER_TOKEN_SCENARIOS = [
    AuthorizationScenario.AuthenticateUserUsingAppToken,
    AuthorizationScenario.AuthenticateUserUsingSmsToken,
    AuthorizationScenario.ChangeToZeroBrokerage,
    AuthorizationScenario.Login,
];

const RESEND_TOKEN_WAIT_TIME = 60;

@AutoUnsubscribe()
@Component({
    selector: 'hub-authorization',
    templateUrl: './hub-authorization.component.html',
    styleUrls: ['./hub-authorization.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class HubAuthorizationComponent extends DialogPanelComponentContent implements OnInit, OnDestroy {

    public authorizationForm: FormGroup;
    public authorizationScenario = AuthorizationScenario;
    public authorizationInProgress: boolean;
    public hasAllowEmail: boolean = false;
    public onTokenAvaliable: EventEmitter<AuthorizationResultPayload> = new EventEmitter();
    public onProcessEnd: EventEmitter<AuthorizationResult> = new EventEmitter();
    public onInvalidToken: EventEmitter<boolean> = new EventEmitter();
    public onResendToken: EventEmitter<boolean> = new EventEmitter();

    public timerSMS: number = 0;
    public timerEmail: number = 0;
    public timer: number = 0;
    private invalidToken: boolean;

    private userProfileSubscription?: Subscription;
    private authenticationSubscription?: Subscription;
    private timerInterval?: NodeJS.Timer;

    public isWebApp: boolean = false;
    public tokenTypeToValidate: TokenTypeToValidate = TokenTypeToValidate.TokenToro;
    public tokenType = TokenChannel;

    public userOffuscatedEmail: string;
    public userLastPhoneNumbers: string;
    public userFirstName: string;

    public pages: AuthorizationPages[] = [];

    constructor(
        public formBuilder: FormBuilder,
        public route: Router,
        private elementRef: ElementRef,
        private dialogReference: MatDialogRef<HubAuthorizationComponent>,
        @Inject(MAT_DIALOG_DATA) public scenario: AuthorizationScenario,
        private formsUtils: FormsUtils,
        private store: Store<AppState>,
        private captchaService: CaptchaService,
    ) {
        super(elementRef, true);
                    // window.zE('messenger:set', 'cookies', false);
        
        const emailAllowed = StorageService.getCookie(ALLOW_EMAIL_COOKIE);

        if (emailAllowed === 'true') {
            this.hasAllowEmail = true;
        }

        this.authenticationSubscription = this.store.select((s) => s.authentication).subscribe((state) => {
            this.userLastPhoneNumbers = state.loginAttempt.lastPhoneNumbers || this.userLastPhoneNumbers;
            this.userOffuscatedEmail = state.loginAttempt.fewEmailChar || this.userOffuscatedEmail;
            this.userFirstName = state.loginAttempt.userFirstName || this.userFirstName;

            if (this.pages.length === 0) {
                const hasDevice = state.loginAttempt.hasDevice === undefined || state.loginAttempt.hasDevice;

                if (hasDevice) {
                    this.pages.push(AuthorizationPages.AuthorizeTokenToro);
                } else {
                    this.pages.push(AuthorizationPages.DownloadApp);
                }
            }
        });

        this.userProfileSubscription = this.store.select((s) => s.userProfile.user)
            .pipe(filter((user) => user.phoneNumber))
            .subscribe((user) => {
                this.userLastPhoneNumbers = user.phoneNumber.substr(user.phoneNumber.length - 4) || this.userLastPhoneNumbers;
            });

        this.createAuthenticationForm();

        // Variável global injetada pelo webapp
        this.isWebApp = StorageService.getCookie('webapp') === 'true';

        if (this.isWebApp) {
            tokenWebApp(this.middleWareAuthorize.bind(this));
        }
    }

    private createAuthenticationForm() {
        const rememberTokenCheckboxChoice = this.getRememberTokenChoice();

        const minMaxLength = this.tokenTypeToValidate === TokenTypeToValidate.TokenToro ? 6 : 5;

        this.authorizationForm = this.formBuilder.group({
            token: [
                "",
                Validators.compose([
                    Validators.required,
                    Validators.minLength(minMaxLength),
                    Validators.maxLength(minMaxLength),
                ]),
            ],
            trustDevice: rememberTokenCheckboxChoice,
        });
    }

    // Função intermediária, para ser chamada antes do autorize quando estiver no ambiente do webapp
    public middleWareAuthorize(token: string) {
        this.authorizationForm.controls.token.setValue(token);
        this.authorize();
        setTimeout(() => {
            this.end();
        }, 800);
    }

    public resetPageTokenTime() {
        this.authorizationForm.controls.token.setValue('');
    }

    /**
     * Envio de Token por SMS
     * @param event Evento
     */
    public sendTokenSMS = async (event: Event = null) => {
        if (!this.timer || this.timer <= 0) {
            if (event) {
                event.preventDefault();
            }

            this.navigateToPage(AuthorizationPages.AuthorizeSmsToken);

            this.onResendToken.emit(!!event);

            this.runTimer();

            // request token SMS
            const captcha = await this.captchaService.getRequestSMSCaptcha();

            this.store.dispatch({
                type: AuthorizationAction.requestTokenTime,
                payload: {
                    channel: TokenChannel.Sms,
                    tokenReason: this.switchAuthorizationReason(),
                    captchaToken: captcha.token,
                    captchaSiteKey: captcha.siteKey,
                }
            });
            this.trackingLoginBtnSendSMS();
        }

        this.tokenTypeToValidate = TokenTypeToValidate.SMS;
        this.resetPageTokenTime();
    }

    /**
     * Authorization Reason
     * @returns Authorization Reason
     */
    public switchAuthorizationReason() {
        return mapScenarioToReason[this.scenario] || mapScenarioToReason._default;
    }

    /**
     * Envio de Token por E-mail
     * @param event Evento
     * @param link se é chamada pelo link
     */
    public sendTokenEmail = async (event: Event = null) => {
        if (!this.timer || this.timer <= 0) {
            if (event) {
                event.preventDefault();
            }

            this.navigateToPage(AuthorizationPages.AuthorizeEmailToken);

            this.onResendToken.emit(!!event);

            this.runTimer();

            // request token Email
            const captcha = await this.captchaService.getRequestSMSCaptcha();

            this.store.dispatch({
                type: AuthorizationAction.requestTokenTime,
                payload: {
                    channel: TokenChannel.Email,
                    tokenReason: this.switchAuthorizationReason(),
                    captchaToken: captcha.token,
                    captchaSiteKey: captcha.siteKey,
                },
            });
            this.trackingLoginBtnSendEmail();
        }

        this.tokenTypeToValidate = TokenTypeToValidate.Email;
        this.resetPageTokenTime();
    }

    private runTimer() {
        this.timer = RESEND_TOKEN_WAIT_TIME;

        this.timerInterval = setInterval(() => {
            if (this.timer > 0) {
                this.timer -= 1;
            } else {
                clearInterval(this.timerInterval);
            }
        }, 1000);
    }

    /**
     * Hanlde form submit
     */
    public authorize = () => {
        this.formsUtils
            .ValidFormBase(this.authorizationForm)
            .then(() => {

                this.authorizationInProgress = true;

                const token = new Token(
                    this.authorizationForm.controls.token.value.toString()
                        .toUpperCase(),
                    TokenType.Time,
                    TokenCategory.Simple,
                );

                const payload = new AuthorizationResultPayload(
                    token,
                    this.authorizationForm.controls.trustDevice.value,
                );

                this.onTokenAvaliable.emit(payload);
            });
    }

    public showOptionToValidToken = () => {
        this.trackingLoginBtnContinue();
        this.pages.push(AuthorizationPages.AuthorizeTokenToro);
    }

    /** Aborda o processo de autorização */
    public cancel = () => {
        if (this.authorizationInProgress) {
            return;
        }
        this.onProcessEnd.emit(AuthorizationResult.Aborted);
        this.dispose(AuthorizationResult.Aborted);
        this.store.dispatch({ type: UsersAction.loginCancel });
    }

    public back = () => {
        clearInterval(this.timerInterval);
        this.timer = 0;

        if (this.pages.length === 1) {
            this.cancel();
            return;
        }

        this.pages.pop();
        this.updateTokenType();
    }

    public showBackButton() {
        return this.pages.length >= 2;
    }

    public showRememberToken() {
        return CAN_REMEMBER_TOKEN_SCENARIOS.includes(this.scenario);
    }

    private updateTokenType() {
        const lastPage = this.pages.slice(-1)[0];

        switch (lastPage) {
            case AuthorizationPages.AuthorizeEmailToken:
                this.tokenTypeToValidate = TokenTypeToValidate.Email;
                break;
            case AuthorizationPages.AuthorizeSmsToken:
                this.tokenTypeToValidate = TokenTypeToValidate.SMS;
                break;
            default:
                this.tokenTypeToValidate = TokenTypeToValidate.TokenToro;
                break;
        }

        this.createAuthenticationForm();
    }

    private navigateToPage = (page: AuthorizationPages) => {
        this.pages.push(page);
        this.updateTokenType();
    }

    private isOnPages = (...pages: AuthorizationPages[]) => {
        const lastPage = this.pages.slice(-1)[0];

        return pages.includes(lastPage);
    }

    public goToHowToUseTokenToro = () => {
        this.navigateToPage(AuthorizationPages.HowToUseTokenToro);
    }

    public goToHelpAlert = () => {
        this.navigateToPage(AuthorizationPages.HelpAlert);
    }

    public showHowToUseTokenToro() {
        return this.isOnPages(AuthorizationPages.HowToUseTokenToro);
    }

    public showPageAuthorizeTokenToro() {
        return this.isOnPages(
            AuthorizationPages.AuthorizeTokenToro,
            AuthorizationPages.AuthorizeSmsToken,
            AuthorizationPages.AuthorizeEmailToken,
        );
    }

    public showPageDownloadApp() {
        return this.isOnPages(AuthorizationPages.DownloadApp);
    }

    public showHelpAlert() {
        return this.isOnPages(AuthorizationPages.HelpAlert);
    }

    /** Reseta o componente para reuniciar o processo */
    public reset() {
        this.authorizationForm.markAsUntouched();
        this.authorizationInProgress = false;
        this.authorizationForm.updateValueAndValidity();
    }

    /** Informa que o token informado é inválido */
    public setTokenAsInvalid() {
        this.setTokenValidity(false);
    }

    /** Informa que o token informado é válido */
    public setTokenAsValid() {
        this.setTokenValidity(true);
    }

    public end() {
        this.authorizationForm.reset();
        this.onProcessEnd.emit(AuthorizationResult.Success);
        this.dispose(AuthorizationResult.Success);
        this.onInvalidToken.emit(false);
    }

    public ngOnDestroy() {
        clearInterval(this.timerInterval);
    }

    /** Tracking clicou em continuar */
    public trackingLoginBtnContinue() {
        this.TrackingElement('btn-login-continue-token-toro');
    }

    /** Tracking clicou em enviar por SMS */
    public trackingLoginBtnSendSMS() {
        this.TrackingElement('btn-login-send-token-sms');
    }

    /** Tracking clicou em enviar por e-mail */
    public trackingLoginBtnSendEmail() {
        this.TrackingElement('btn-login-send-token-email');
    }

    /** Tracking clicou em whatsapp consultoria */
    public trackingLoginBtnHelpWhatsApp() {
        this.TrackingElement('btn-login-help-whatsapp');
    }

    /** Tracking Login */
    private handleTrackingLogin(success: boolean) {
        if (this.authorizationForm.controls.token.value.length === 6) {
            this.TrackingElement(`login-${success ? 'success' : 'error'}-token-toro`);
        } else {
            this.TrackingElement(`login-${success ? 'success' : 'error'}-tokentime`);
        }
    }

    public handleTrackingCheckboxToogle = (checked: boolean) => {
        const eventType = checked ? "Marcado" : "Desmarcado";
        const tokenType: string = TokenTypeToValidate[this.tokenTypeToValidate];

        this.TrackingElement(
            `Checkbox Lembrar Token ${eventType} ${tokenType}`
        );

        this.storeRememberTokenChoice(checked);
    };

    private storeRememberTokenChoice(checked: boolean) {
        const today = new Date();
        const todayYear = today.getFullYear();
        const todayMonth = today.getMonth();
        const todayDay = today.getDate();

        const todayPlusOneMonth = new Date(todayYear, todayMonth + 1, todayDay);

        StorageService.setCookie(REMEMBER_TOKEN_CHECKBOX_STORAGE_KEY, `${!!checked}`, todayPlusOneMonth);
    }

    private getRememberTokenChoice() {
        const storedValue = StorageService.getCookie(REMEMBER_TOKEN_CHECKBOX_STORAGE_KEY);

        if (storedValue == 'false') {
            return false;
        }

        return true;
    }

    /** Tracking Element */
    private TrackingElement(element: string) {
        const origin = AuthorizationScenario[this.scenario];

        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
                type: "User Clicked",
                events: { origin, element },
            },
        });
    }

    /** Finaliza o componente */
    private dispose(result: AuthorizationResult.Aborted | AuthorizationResult.Success) {
        this.close(this.dialogReference, result);
    }

    /**
     * Define a validade do token (valido ou não)
     * @param valid valido
     */
    private setTokenValidity(valid: boolean = false) {
        this.invalidToken = !valid;
        if (this.invalidToken) {
            this.authorizationForm.get('token')
                .setErrors({ backendError: { message: 'Código inválido.' } });
            this.onInvalidToken.emit(true);
        } else {
            this.authorizationForm.get('token')
                .setErrors(null);
                            // window.zE('messenger:set', 'cookies', true);
                    }


        this.handleTrackingLogin(!this.invalidToken);
    }

    public setAcceptEmail(accept: boolean = false) {
        this.hasAllowEmail = accept;
    }
}
